export namespace TableUtils {
  enum Status {
    Approved = 'APPROVED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
  }

  export function getStatusCellColor(status: string) {
    switch (status) {
      case Status.Approved:
        return 'var(--palette-success-main)';
      case Status.Pending:
        return 'var(--palette-warning-main)';
      case Status.Rejected:
        return 'var(--palette-error-main)';
      default:
        return 'inherit';
    }
  }
}
